export function realtimePlaybackTransition(eventType, audioPlaybackActive) {
  if (eventType === 'output_audio_buffer.started') {
    return { audioPlaybackActive: true, turnFinished: false };
  }

  if (
    eventType === 'output_audio_buffer.stopped'
    || eventType === 'output_audio_buffer.cleared'
  ) {
    return { audioPlaybackActive: false, turnFinished: true };
  }

  if (eventType === 'response.done') {
    return {
      audioPlaybackActive,
      turnFinished: !audioPlaybackActive,
    };
  }

  return { audioPlaybackActive, turnFinished: false };
}

export function candidateTurnTransition(eventType) {
  if (eventType === 'input_audio_buffer.speech_started') {
    return {
      candidateSpeaking: true,
      candidateTurnObserved: true,
      cancelPendingResponse: true,
      scheduleResponse: false,
    };
  }

  if (
    eventType === 'input_audio_buffer.speech_stopped'
    || eventType === 'input_audio_buffer.committed'
    || eventType === 'conversation.item.input_audio_transcription.completed'
  ) {
    return {
      candidateSpeaking: false,
      candidateTurnObserved: true,
      cancelPendingResponse: false,
      scheduleResponse: true,
    };
  }

  if (eventType === 'conversation.item.input_audio_transcription.delta') {
    return {
      candidateSpeaking: true,
      candidateTurnObserved: true,
      cancelPendingResponse: false,
      scheduleResponse: false,
    };
  }

  return {
    candidateSpeaking: false,
    candidateTurnObserved: false,
    cancelPendingResponse: false,
    scheduleResponse: false,
  };
}
